import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-lcl-shipment-tracking-state',
  templateUrl: './lcl-shipment-tracking-state.component.html',
  styleUrls: ['./lcl-shipment-tracking-state.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LclShipmentTrackingStateComponent {
  @Input() public currentState: number;

  public SHIPMENT_STATES: Array<{ icon: string; label: string }> = [
    {
      icon: '/assets/icons/shipment/done.svg',
      label: this.translateService.instant('LCL_TRACKING_STATE.BOOKING_PLACED'),
    },
    {
      icon: '/assets/icons/shipment/warehouse.svg',
      label: this.translateService.instant('LCL_TRACKING_STATE.AT_ORIGIN_WAREHOUSE'),
    },
    {
      icon: '/assets/icons/shipment/vessel.svg',
      label: this.translateService.instant('LCL_TRACKING_STATE.IN_TRANSIT'),
    },
    {
      icon: '/assets/icons/shipment/warehouse.svg',
      label: this.translateService.instant('LCL_TRACKING_STATE.AT_DESTINATION_WAREHOUSE'),
    },
    {
      icon: '/assets/icons/shipment/done.svg',
      label: this.translateService.instant('LCL_TRACKING_STATE.DELIVERED'),
    },
  ];

  constructor(private translateService: TranslateService) {}
}
